"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _cccisdTooltip = _interopRequireDefault(require("cccisd-tooltip"));
var _cccisdWysiwyg = require("cccisd-wysiwyg");
var _cccisdConfirm = _interopRequireDefault(require("cccisd-confirm"));
var _cccisdToggle = _interopRequireDefault(require("cccisd-toggle"));
var _style = _interopRequireDefault(require("./style.css"));
var _bin = _interopRequireDefault(require("cccisd-icons/bin"));
var _info = _interopRequireDefault(require("cccisd-icons/info2"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var CollectionItem = function CollectionItem(props) {
  var _styleConfig$resource, _styleConfig$resource2, _styleConfig$resource3;
  var item = props.item,
    removeFromCollection = props.removeFromCollection,
    session = props.session,
    setSessions = props.setSessions,
    toggle = props.toggle,
    disableTimepoints = props.disableTimepoints,
    styleConfig = props.styleConfig,
    controlAllSessions = props.controlAllSessions,
    sessionsForTab = props.sessionsForTab,
    updateSessionsForBucket = props.updateSessionsForBucket,
    bucketName = props.bucketName,
    timepointsHaveDefaultSettings = props.timepointsHaveDefaultSettings,
    setTimepointsHaveDefaultSettings = props.setTimepointsHaveDefaultSettings;
  var id = item.id,
    label = item.label,
    description = item.description,
    tags = item.tags;
  var tagList = Object.values(tags);
  var styleProps = props.style;
  var metadata = JSON.parse(item.resource.published_metadata);
  var reporterType = metadata.audience;
  var surveyInfo = metadata.surveyInfo;
  var onChangeSurveyToggle = function onChangeSurveyToggle() {
    if (controlAllSessions) {
      var sessionsCopy = _toConsumableArray(sessionsForTab);
      var updateSessions = function updateSessions() {
        // Update the "master" session we are using to control all sessions
        session.settings.disabledSurveys.includes(item.id) ? session.settings.disabledSurveys = session.settings.disabledSurveys.filter(function (s) {
          return s !== item.id;
        }) : session.settings.disabledSurveys.push(item.id);
        session.settings.options = props.getSurveyHandles(session.settings.sessionCollection, session.settings.disabledSurveys);
        sessionsCopy.forEach(function (currentSession) {
          currentSession.settings.disabledSurveys = _toConsumableArray(session.settings.disabledSurveys);
          currentSession.settings.options = _toConsumableArray(session.settings.options);
        });
        updateSessionsForBucket(bucketName, sessionsCopy);
      };
      if (!timepointsHaveDefaultSettings) {
        (0, _cccisdConfirm["default"])({
          message: 'Apply default settings to all timepoints?',
          description: "Some timepoints are using different settings. This will overwrite them with the default settings.",
          confirmLabel: 'Yes',
          abortLabel: 'Cancel'
        }).then(function () {
          updateSessions();
          setTimepointsHaveDefaultSettings(true);
        });
        return sessionsCopy;
      }
      updateSessions();
      return sessionsCopy;
    }
    return setSessions(function (prev) {
      var sessionsCopy = _toConsumableArray(prev);
      var currentSession = sessionsCopy.find(function (s) {
        return s.settings.sessionId === session.settings.sessionId;
      });
      currentSession.settings.disabledSurveys.includes(item.id) ? currentSession.settings.disabledSurveys = currentSession.settings.disabledSurveys.filter(function (s) {
        return s !== item.id;
      }) : currentSession.settings.disabledSurveys.push(item.id);
      currentSession.settings.options = props.getSurveyHandles(currentSession.settings.sessionCollection, currentSession.settings.disabledSurveys);
      setTimepointsHaveDefaultSettings(false);
      return sessionsCopy;
    });
  };
  var renderActions = function renderActions() {
    if (toggle && disableTimepoints) {
      return null;
    }
    if (toggle) {
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].toggle
      }, /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
        title: "Enable/disable survey"
      }, /*#__PURE__*/_react["default"].createElement(_cccisdToggle["default"], {
        onChange: onChangeSurveyToggle,
        value: !session.settings.disabledSurveys.includes(item.id)
      })));
    }
    if (item.progress && item.progress.end) {
      return null;
    }
    return /*#__PURE__*/_react["default"].createElement("button", {
      type: "button",
      className: "btn btn-secondary btn-xs",
      style: {
        alignSelf: 'end'
      },
      onClick: function onClick() {
        return removeFromCollection(id);
      }
    }, /*#__PURE__*/_react["default"].createElement(_bin["default"], null));
  };
  if (surveyInfo) {
    label = surveyInfo.surveyLabel;
  }
  var tagsString = tagList.join(', ');
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: (styleProps === null || styleProps === void 0 ? void 0 : styleProps.item) || _style["default"].item
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].content
  }, description ? /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
    title: /*#__PURE__*/_react["default"].createElement("span", {
      className: (styleProps === null || styleProps === void 0 ? void 0 : styleProps.toolTip) || _style["default"].toolTip
    }, /*#__PURE__*/_react["default"].createElement(_cccisdWysiwyg.Html, {
      content: description || ''
    })),
    type: "info"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: (styleProps === null || styleProps === void 0 ? void 0 : styleProps.label) || _style["default"].label,
    style: styleConfig ? {
      color: (_styleConfig$resource = styleConfig.resources) === null || _styleConfig$resource === void 0 ? void 0 : _styleConfig$resource.titleColor
    } : {}
  }, label, /*#__PURE__*/_react["default"].createElement(_info["default"], {
    spaceLeft: true
  }))) : /*#__PURE__*/_react["default"].createElement("div", {
    className: (styleProps === null || styleProps === void 0 ? void 0 : styleProps.label) || _style["default"].label,
    style: styleConfig ? {
      color: (_styleConfig$resource2 = styleConfig.resources) === null || _styleConfig$resource2 === void 0 ? void 0 : _styleConfig$resource2.titleColor
    } : {}
  }, label), reporterType && /*#__PURE__*/_react["default"].createElement("div", {
    className: (styleProps === null || styleProps === void 0 ? void 0 : styleProps.reporter) || _style["default"].reporter
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: (styleProps === null || styleProps === void 0 ? void 0 : styleProps.reporterLabel) || _style["default"].reporterLabel
  }, "Reporter:"), /*#__PURE__*/_react["default"].createElement("span", {
    style: {
      marginLeft: '0.5em'
    }
  }, reporterType)), ((_styleConfig$resource3 = styleConfig.resources) === null || _styleConfig$resource3 === void 0 ? void 0 : _styleConfig$resource3.showTags) && /*#__PURE__*/_react["default"].createElement("div", {
    className: (styleProps === null || styleProps === void 0 ? void 0 : styleProps.tags) || _style["default"].tags
  }, /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
    title: /*#__PURE__*/_react["default"].createElement("span", {
      className: (styleProps === null || styleProps === void 0 ? void 0 : styleProps.toolTip) || _style["default"].toolTip
    }, /*#__PURE__*/_react["default"].createElement(_cccisdWysiwyg.Html, {
      content: tagsString || ''
    })),
    type: "info"
  }, tagsString))), /*#__PURE__*/_react["default"].createElement("div", {
    className: (styleProps === null || styleProps === void 0 ? void 0 : styleProps.actions) || _style["default"].actions
  }, renderActions()));
};
var _default = exports["default"] = CollectionItem;